const HeaderHeight = () => {
    const root = document.querySelector(':root')

    const setHeaderHeightVar = () => {
        const header = document.querySelector('header')
        root.style.setProperty('--headerHeight', `${header?.offsetHeight}px`)
    }

    setHeaderHeightVar()
    window.addEventListener('resize', (_) =>
        requestAnimationFrame(setHeaderHeightVar)
    )

    return true
}

export default HeaderHeight
